import { connect } from 'react-redux'
import { injectIntl } from 'react-intl'
import ListFromTable from 'components/common/ListFromTable'
import * as AppRouter from 'constants/appRouting'
import ColumnCollection from 'types/table/ColumnCollection'
import Column from 'types/table/Column'
import Sort from 'lib/psfs/Sort'
import ActionCollection from 'types/table/ActionCollection'
import Action from 'types/table/Action'
import UrlHelper from 'helpers/url'
import {
  fetchLocusGroupTable,
  deleteLocusGroupInfo,
  clearLocusGroupStore,
} from 'reducers/locusGroup/reducer'
import ActiveColumn from 'types/table/ActiveColumn'
import DateColumn from 'types/table/DateColumn'
import messages from './translate'

class LocusGroupList extends ListFromTable {
  constructor(props) {
    super(props)
    this.getTableData = props.fetchLocusGroupTable
    this.deleteEntity = props.deleteLocusGroupInfo
    this.clearReducerState = props.clearLocusGroupStore
    this.asyncData = true
    this.loadingData = true
  }

  shouldComponentUpdate(nextProps, nextState, nextContext) {
    this.loadingData = nextProps.loader

    if (nextProps.licenseeId !== this.props.licenseeId) {
      this.reloadTableData(AppRouter.LOCUS_GROUP_LIST)

      return false
    }

    if (this.props.tableData !== nextProps.tableData) {
      this.loadingData = false
    }

    return super.shouldComponentUpdate(nextProps, nextState, nextContext)
  }

  getTableProps() {
    const {
      intl: { formatMessage },
    } = this.props

    return {
      title: formatMessage(messages.unitGroupList),
      showFilterBar: true,
      sorting: true,
      paging: true,
      searching: true,
      creating: true,
    }
  }

  getCreateButton() {
    const {
      intl: { formatMessage },
    } = this.props

    return {
      title: formatMessage(messages.createUnitGroup),
      link: AppRouter.LOCUS_GROUP_CREATE,
    }
  }

  getConfirmDialogProps() {
    const {
      intl: { formatMessage },
    } = this.props

    return {
      title: formatMessage(messages.deleteUnitGroup),
      message: formatMessage(messages.deleteUnitGroupMessage),
    }
  }

  getColumns() {
    const {
      intl: { formatMessage },
    } = this.props
    const columns = new ColumnCollection()

    columns.add(new Column('id', 'ID', { sorting: true }))
    columns.add(
      new Column('name', formatMessage(messages.name), {
        sorting: true,
        defaultSort: true,
        defaultSortOrder: Sort.ASC,
      }),
    )
    columns.add(
      new Column('site', formatMessage(messages.site), {
        sorting: true,
        render: rowData => rowData.site.name,
      }),
    )
    columns.add(
      new ActiveColumn('visibleInUi', formatMessage(messages.visibleInUi), {
        sorting: true,
      }),
    )
    columns.add(
      new DateColumn('dateUpdated', formatMessage(messages.dateUpdated), {
        sorting: true,
      }),
    )

    return columns
  }

  getActions() {
    const {
      history,
      intl: { formatMessage },
    } = this.props
    const actions = new ActionCollection()

    actions.add(
      new Action('edit', formatMessage(messages.editUnitGroup), row => {
        history.push(
          UrlHelper.create(AppRouter.LOCUS_GROUP_EDIT, { id: row.id }),
        )
      }),
    )
    actions.add(
      new Action('delete', formatMessage(messages.deleteUnitGroup), row => {
        this.onOpenConfirmDialog({ entityId: row.id, psfs: this.psfs })
      }),
    )

    return actions
  }
}

export default connect(
  state => ({
    tableData: state.getIn(['locusGroup', 'tableData']),
    loader: state.getIn(['locusGroup', 'isLoadTable']),
    licenseeId: state.getIn(['profile', 'licenseeId']),
  }),
  {
    fetchLocusGroupTable,
    deleteLocusGroupInfo,
    clearLocusGroupStore,
  },
)(injectIntl(LocusGroupList))
